<div fxLayout="column" (mouseleave)="close()">
  <div fxLayout="row" fxLayoutAlign="start center">
    <label fxFlex="100">Πρότυπα φορμών</label>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div fxLayout="row wrap" style="margin-top: 20px; margin-left: auto; margin-right: auto;">

    <div *ngFor="let template of templates; let i = index;" (click)="setSelectedTemplate(i)"
          fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center center" style="margin-bottom: 5px;">
        <label>{{template.name}}</label>
      </div>
      <template class="template" [ngClass]="selectedTemplate === i ? 'selected' : ''" fxLayout="column">

        <div *ngFor="let row of template.rows" style="margin-top: 1px; padding: 5px;">

          <mat-grid-list [cols]="row.columns" gutterSize="7.5px" rowHeight="25px">
            <mat-grid-tile *ngFor="let member of row.members">
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </template>


    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="end center">
      <button mat-flat-button (click)="returnSelected()">Επιλογή</button>
    </div>
  </div>
